import { useQuery } from 'react-query';
import { apiGetJson } from '~/core/dapi';
import { getImageUrlDownloadUrl } from '~/core/dapi/images';
import { isAwsLink } from '../util';

type Props = {
  queryKey: string;
  photoId: string;
  imgUrl?: string;
};

interface ImageResponse {
  image_url: string;
}

export const useImageUrl = ({ queryKey, photoId, imgUrl }: Props) => {
  return useQuery([queryKey, imgUrl, photoId], async () => {
    if (imgUrl && !isAwsLink(imgUrl)) {
      return imgUrl;
    }
    if (!photoId) {
      return undefined;
    }
    const response = await apiGetJson<ImageResponse>(getImageUrlDownloadUrl(photoId));
    return response.data?.image_url;
  });
};
